<template>
  <div class="content-box">
    <fieldset>
      <legend><span>Passport</span></legend>
      <v-row>
        <v-col cols="4"><p class="label">Passport User Activity ID</p></v-col>
        <v-col cols="8"><v-text-field :value="main.transid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
    <fieldset>
      <legend><span>Performance</span></legend>
      <v-row>
        <v-row>
          <v-col cols="4"><p class="label">Response time (ms)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.resptime | comma" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="4"><p class="label">CPU time (ms)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.cputime" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4"><p class="label">External time (ms)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.externaltime | comma" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="4"><p class="label">DB time (ms)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.dbtime" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4"><p class="label">DB Calls</p></v-col>
          <v-col cols="2"><v-text-field :value="main.dbcalls | comma" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="4"><p class="label">DB Traffic (bytes)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.dbio" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4"><p class="label">Received bytes</p></v-col>
          <v-col cols="2"><v-text-field :value="main.receivedbytes | comma" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="4"><p class="label">Sent bytes</p></v-col>
          <v-col cols="2"><v-text-field :value="main.sentbytes" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4"><p class="label">Allocated memory (MB)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.allocmem | comma" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="4"><p class="label">Session size (MB)</p></v-col>
          <v-col cols="2"><v-text-field :value="main.sessionsize" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
      </v-row>
    </fieldset>
    <fieldset>
      <legend><span>Additional information</span></legend>
      <v-row>
        <v-col cols="4"><p class="label">Additional information</p></v-col>
        <v-col cols="8"><v-text-field :value="main.addinfo" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { merge } from 'lodash';
import tabable from './tabable';

export default {
  mixins: [tabable],
  computed: {
    ...mapState('analysis/dsr', ['main']),
  },
  methods: {
    ...mapActions('analysis/dsr', ['fetchMain']),
    async fetch(params) {
      await this.fetchMain(
        merge({}, params, {
          starttimel: this.step.starttimel,
        }),
      );
      this.increaseLoadingCount();
    },
  },
};
</script>
<style lang="scss" scoped>
.content-box {
  padding: 0px;
}
fieldset {
  margin-top: 10px;
  padding: 10px;
  border-width: 1px;
}
fieldset legend {
  padding: 0px 10px;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
